const SOFT_SKILLLS = 'SOFT_SKILLLS';
const HARD_SKILLS = 'HARD_SKILLS';
const TOPIC_CATEGORIES = {
  SOFT_SKILLLS: 1,
  HARD_SKILLS: 2,
};

export { SOFT_SKILLLS, HARD_SKILLS, TOPIC_CATEGORIES };
